/**
 * 语言配置-英语
 */
export const en_Language = {

}



// WEBPACK FOOTER //
// ./src/language/package/en.js